import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 270;

export default makeStyles((theme) => ({
  toolbar: {
    paddingInline: '20px',
  },
  toolbarIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    alignSelf: 'flex-end',
  },
  appBar: {
    maxHeight: 64,
    backgroundColor: '#FFF',
    color: '#101D40',
    borderBottom: '2px solid #DBDFE9',
    zIndex: theme.zIndex.drawer + 1,
    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  },
  menuButton: {
    marginRight: 8,
    position: 'relative',
    '& > span': {
      alignItems: 'flex-start',
    }
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    flexGrow: 1,
  },
  drawerClosed: {
    width: '0px !important',
    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  },
  drawer: {
    width: drawerWidth,
    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    flexShrink: 0,
    '& > div': {
      borderRight: '1px solid rgba(124, 141, 181, 0.25)',
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#FBFBFB',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0px',
      height: '0px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      border: '0px none #ffffff',
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a1a1a1',
    },
    '&::-webkit-scrollbar-thumb:active': {
      backgroundColor: '#8a8a8a',
    },
    '&::-webkit-scrollbar-track': {
      background: '#e1e1e1',
      border: '0px none #ffffff',
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-track:hover': {
      background: '#e1e1e1',
    },
    '&::-webkit-scrollbar-track:active': {
      background: '#e1e1e1',
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  list: {
    padding: '0px',
  },
  licenseButtonWarning: {
    width: '38px',
    height: '38px',
    borderRadius: '5px',
    marginRight: '10px',
    backgroundColor: 'rgba(255, 137, 70, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255, 137, 70, 0.25)',
    },
  },
  licenseButtonExpired: {
    width: '38px',
    height: '38px',
    borderRadius: '5px',
    marginRight: '10px',
    backgroundColor: 'rgba(246, 68, 68, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(246, 68, 68, 0.25)',
    },
  },
  logoutButton: {
    width: '38px',
    height: '38px',
    borderRadius: '5px',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
  },
  divider: {
    backgroundColor: 'rgba(124, 141, 181, 0.25)',
    marginInline: '24px',
  },
  avatar: {
    width: '70px',
    height: '70px',
  },
  companyName: {
    marginTop: '16px',
    color: '#101D40',
    fontSize: '16px',
    fontFamily: 'Sora, sans-serif',
    fontWeight: 700,
    textAlign: 'center',
  },
  whatsApp: {
    fontWeight: 600,
    fontFamily: 'Sora, sans-serif',
    fontSize: '15px',
    padding: '30px 0 15px',
  },
  openCloseStoreButton: {
    padding: '9px 12px 9px 12px',
    borderRadius: '5px',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    border: '1px solid rgba(124, 141, 181, 0.25)',
    transition: 'backgroundColor 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(215, 222, 233, 0.60)',
    },
  },
  openCloseStoreText: {
    fontWeight: 700,
    fontSize: '14px',
    color: '#101D40',
    marginLeft: '8px',
    fontFamily: 'Sora, sans-serif',
  },
  ifoodInfo: {
    fontWeight: 700,
    fontSize: '14px',
    color: '#101D40',
    marginLeft: '8px',
    fontFamily: 'Sora, sans-serif',
  },
}));
